"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalNavListMixin = void 0;
var _styledComponents = require("styled-components");
var _listResetMixin = require("../listResetMixin");
var _spacingMixin = require("../spacingMixin");
/** @class VerticalNavListMixin */
/** @method */

var VerticalNavListMixin = function VerticalNavListMixin(props) {
  return (0, _styledComponents.css)(["", " ", ""], _listResetMixin.listResetMixin, (0, _spacingMixin.spacingMixin)(props));
};
exports.VerticalNavListMixin = VerticalNavListMixin;